// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nqc6eoc_QdTtBh {
  overflow: visible;
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ {
  width: 640px;
  margin: var(--ds-space-0, 0) auto;
  transition: width 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ {
    transition: none;
  }
}
.Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.g0DDcnZtnJUWeu {
  width: 1084px;
}
@media only screen and (min-width: 601px) and (max-width: 1099px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
  }
}
@media only screen and (max-width: 600px) {
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ,
  .Nqc6eoc_QdTtBh.zEJCz43wCjFqhZ.g0DDcnZtnJUWeu {
    width: calc(100vw - var(--ds-space-200, 16px));
    margin: var(--ds-space-400, 32px) var(--ds-space-100, 8px) var(--ds-space-0, 0);
  }
}
@media only screen and (max-width: 750px) {
  .Nqc6eoc_QdTtBh > div {
    /* stylelint-disable-next-line declaration-no-important */
    margin: var(--ds-space-0, 0) !important;
  }
}
`, ""]);
// Exports
export var cardBackDialog = `Nqc6eoc_QdTtBh`;
export var cardBackRedesign = `zEJCz43wCjFqhZ`;
export var withPanel = `g0DDcnZtnJUWeu`;
export default ___CSS_LOADER_EXPORT___;
